require("bootstrap-daterangepicker/daterangepicker.css");

import 'bootstrap-daterangepicker';

function enableDateFields($scope) {
  const submitDateFormat = 'DD/MM/YYYY HH:mm';

  function clearDate(event) {

    // don't submit the form.
    event.preventDefault();

    // find a bunch of relevant elements.
    var $dateField = $(event.target).closest('.date-input').find('input');

    // clear the cloudinary id.
    $dateField.val(null);

  }

  $scope.find('input.single-daterange-with-time').each(function () {
    const $input = $(this);
    const dateFormat = $input.attr('date_format') || submitDateFormat;

    // Remove any previous daterangepicker instance to avoid duplicates or re-init.
    if ($input.data('daterangepicker')) {
      $input.data('daterangepicker').remove();
    }

    const isPastOnly = $input.hasClass('past-only');

    $input.daterangepicker({
      singleDatePicker: true,
      timePicker: true,
      autoUpdateInput: false,
      parentEl: $input.closest('.date-input')[0],
      maxDate: isPastOnly ? new Date() : undefined,
      minDate: isPastOnly ? '01/01/2020' : undefined,
      showDropdowns: isPastOnly,
      locale: {
        cancelLabel: 'Clear',
        format: dateFormat,
      }
    });

    $input.off('apply.daterangepicker cancel.daterangepicker');

    $input.on('apply.daterangepicker', function (ev, picker) {
      $(this).val(picker.startDate.format(dateFormat));
    });

    $input.on('cancel.daterangepicker', function () {
      $(this).val('');
    });
  });

  $scope.find(".date-input button.clear").off('click').on('click', clearDate);
}

$(document).on('turbolinks:load', function () {
  enableDateFields($('body'));
});

$(document).on('sprinkles:update', function (event) {
  enableDateFields($(event.target));
});
